import create from 'zustand';
import { EditQueryState } from './interfaces/EditQueryState';

export const useEditQueryStore = create<EditQueryState>((set) => ({
  editMode: false,
  allowCancelEditing: true,
  allowEditModeWithoutConfirmation: true,
  toggleEditMode: () => set((state) => ({ editMode: !state.editMode })),
  setCancelEditing: (value: boolean) => set(() => ({ allowCancelEditing: value })),
  setAllowEditModeWithoutConfirmation: (value: boolean) =>
    set(() => ({ allowEditModeWithoutConfirmation: value }))
}));
